import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractAndTrim'
})
export class ExtractAndTrimPipe implements PipeTransform {

  transform(elements: any[] | null, propertyName: string, maxLength: number = 3): string[] {
    if (!elements) return [];
    const properties = elements.map(user => user[propertyName]);
    return this.trim(properties, maxLength);
  }

  private trim(properties: any[], maxLength: number): string[] {
    return properties.length > maxLength ? properties.slice(0, maxLength).concat('...') : properties;
  }

}
